module.exports = {"langsAvailable":["fr","en"],"pagesSlug":{"404":"four-o-four","contact":"contact","home":"home","legalNotice":"legal-notice","restaurant":"restaurant","chef":"chef","menu":"menu","bookingModal":"booking-modal","loadingModal":"loading-modal"}}


//////////////////
// WEBPACK FOOTER
// ./static/json/global.json
// module id = 207
// module chunks = 0